"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGlBinder = void 0;
/**
 * @public
 * Data binder for webgl graphics components.
 */
class AGlBinder {
    update(connector, componentRenderer) {
        this.updateData(connector);
        this.updatePointers(connector);
        this.bindUniforms(componentRenderer);
        this.bindAttributes(componentRenderer);
    }
}
exports.AGlBinder = AGlBinder;
//# sourceMappingURL=a-gl-binder.js.map